import React from 'react'
import _ from 'lodash'
import { Radar, Doughnut } from 'react-chartjs'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { Link } from 'react-router'
import CharCoordinates from '../Patient/Component/CharCoordinates'
import PieChar from '../Patient/Component/PieChar'
export default class DashboardCharts extends React.Component {
  constructor(props) {
    super(props)
    this.state = ({
      indiceDeReservaFuncional: {},
      reservaFuncional: {}
    })
    this.width = 263
  }

  componentDidMount() {
    const indiceDeReservaFuncional = {
      labels: ['Arterial', 'Metabólica', 'Cardiopulmonar', 'Bienestar', 'Vigor'],
      datasets: [
        {
          label: 'Calculo',
          fillColor: 'rgba(30, 124, 144, 0.4)',
          strokeColor: 'rgba(30, 124, 144, 0.8)',
          highlightFill: 'rgba(30, 124, 144, 0.5)',
          highlightStroke: 'rgba(30, 124, 144, 0.8)',
          data: [this.props.indiceDeReservaFuncional.fxArterial,
          this.props.indiceDeReservaFuncional.fxMetabolica,
          this.props.indiceDeReservaFuncional.fxCardioPulmonar,
          this.props.indiceDeReservaFuncional.balanceAfectivoYBienestar,
          this.props.indiceDeReservaFuncional.vigorNeuromuscular
          ]
        }
      ]
    }

    const reservaFuncional = [{
      value: this.props.reservaFuncional.capacidadFuncional,
      color: 'rgba(30, 124, 144, 0.7)',
      label: 'Reserva funcional'
    }, {
      value: this.props.reservaFuncional.perdidaCapacidadFuncional,
      color: 'rgba(198, 31, 40, 0.5)',
      label: 'Capacidad perdida'
    }]
    this.setState({
      indiceDeReservaFuncional: indiceDeReservaFuncional,
      reservaFuncional: reservaFuncional
    })
  }

  render() {
    let { ShowAfecto, animate, health } = this.props
    const rol = localStorage.rol_name
    debugger
    let url = `percentil/${this.props.id}/${health._id}/${this.props.patient}`
    const chartOptions = {
      pointLabelFontSize: 12, scaleShowLabels: true,
      scaleStartValue: 0, scaleOverride: true,
      pointLabelFontColor: '#EFEFEF', scaleSteps: 5, scaleStepWidth: 2,
      scaleFontColor: '#EFEFEF', scaleLineColor: '#EFEFEF',
      angleLineColor: 'rgba(255,255,255,0.5)', responsive: true,
      scaleBackdropColor: 'rgba(255,255,255,0.75)'
    }
    let afectoData = {
      preocupacion: 0,
      contento: 0,
      tranquilo: 0,
      desanimo: 0,
      optimista: 0,
      satisfecho: 0,
      irritable: 0,
      decepcionado: 0,
      bienestar: 0,
      malestar: 0,
      afectoX: 0,
      afectoY: 0
    }
    if (_.isEmpty(this.props.data)) {
      afectoData = {
        preocupacion: 0,
        contento: 0,
        tranquilo: 0,
        desanimo: 0,
        optimista: 0,
        satisfecho: 0,
        irritable: 0,
        decepcionado: 0,
        bienestar: 0,
        malestar: 0,
        afectoX: 0,
        afectoY: 0
      }
    } else {
      afectoData = this.props.data[0]
      try {
        this.width = document.getElementById('containerG').offsetWidth / 2
      } catch (e) {

      }
    }
    const doughnutOptions = {
      segmentShowStroke: false, animateRotate: true,
      animateScale: false, percentageInnerCutout: 50,
      tooltipTemplate: '<%= value %>%'
    }
    let className_ = ''
    if (animate && this.props.afecto === false) {
      className_ = 'animated bounceIn tab_A'
    }

    var { reservaFuncional } = this.state
    if (!_.isEmpty(reservaFuncional)) {
      try {
        reservaFuncional[0].value = reservaFuncional[0].value.toFixed(1)
        reservaFuncional[1].value = reservaFuncional[1].value.toFixed(1)
      } catch (r) { }
    }
    let width = this.width
    return (
      <div className='chart-section'>
        <div className='container-slide'>
          <Tabs selectedIndex={1}>
            <TabList>
              <Tab>Indice de reserva funcional</Tab>
              <Tab>Reserva funcional</Tab>
              {ShowAfecto && (rol != 'general sura') ? (
                <Tab className={className_}>Afecto</Tab>
              ) : null}
            </TabList>
            <TabPanel>
              <div className='healt-squares'>
                <Radar data={this.state.indiceDeReservaFuncional} className='chart chart-radar' options={chartOptions} redraw />
              </div>
            </TabPanel>
            <TabPanel>
              <div className='healt-squares'>
                <Doughnut data={reservaFuncional} className='chart chart-doughnut' height='260' width='520' options={doughnutOptions} redraw />
              </div>
            </TabPanel>
            {ShowAfecto && (rol != 'general sura') ? (
              <TabPanel>
                <div className='healt-squares'>
                  {this.props.afecto === true ? (
                    <div id='containerG'>
                      <CharCoordinates vector={afectoData} width={width} height={width}></CharCoordinates>
                      <PieChar vector={afectoData} width={width} height={width}></PieChar>
                      <Link className='remember conditions-container special-conditions' to={url}>Modificar</Link>
                    </div>
                  ) : <Link className='remember conditions-container special-conditions' to={url}>Tomar Medicion</Link>}

                </div>
              </TabPanel>) : null}
          </Tabs>
        </div>
      </div>
    )
  }
}

DashboardCharts.propTypes = {
  id: React.PropTypes.string,
  health: React.PropTypes.string,
  afecto: React.PropTypes.any,
  ShowAfecto: React.PropTypes.any,
  patient: React.PropTypes.string,
  indiceDeReservaFuncional: React.PropTypes.object,
  reservaFuncional: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/EstaDoSaludDashboard/DashboardChartComponent.js